import type { CreatureSpellcastingEssenceInput, CreatureSpellcastingEssenceResult } from '../types';

export const BODY_ESSENCE_ID = '22918408-67CC-4093-80E8-BF6FA8915C21';
export const MIND_ESSENCE_ID = '63ABC96E-3804-4E1F-B38D-AABA3237B2D8';
export const SOUL_ESSENCE_ID = '72F93730-134F-4CA2-8FC4-F2915F20CAC6';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const integer = (value: number): number => {
    const result = Math.trunc(Number.isFinite(value) ? value : 0);
    return Object.is(result, -0) ? 0 : result;
};

/** Select a resolved spellcasting essence and its rolled essence modifier. */
export function compileCreatureSpellcastingEssence(input: CreatureSpellcastingEssenceInput): CreatureSpellcastingEssenceResult {
    const values = {
        [BODY_ESSENCE_ID]: integer(input.essenceValues[BODY_ESSENCE_ID] ?? 0),
        [MIND_ESSENCE_ID]: integer(input.essenceValues[MIND_ESSENCE_ID] ?? 0),
        [SOUL_ESSENCE_ID]: integer(input.essenceValues[SOUL_ESSENCE_ID] ?? 0),
    };
    let essence = input.existingEssenceUuid;
    if (essence === '') {
        essence = values[BODY_ESSENCE_ID] >= values[MIND_ESSENCE_ID] && values[BODY_ESSENCE_ID] >= values[SOUL_ESSENCE_ID]
            ? BODY_ESSENCE_ID
            : values[MIND_ESSENCE_ID] >= values[BODY_ESSENCE_ID] && values[MIND_ESSENCE_ID] >= values[SOUL_ESSENCE_ID]
                ? MIND_ESSENCE_ID
                : SOUL_ESSENCE_ID;
    } else if (input.hasSecondClass) {
        const candidates = [...new Set(input.classEssenceUuids.filter((candidate) => UUID.test(candidate)))];
        if (candidates.length > 1) {
            let best = candidates[0]!;
            for (const candidate of candidates.slice(1)) {
                if (integer(input.essenceValues[candidate] ?? 0) > integer(input.essenceValues[best] ?? 0)) best = candidate;
            }
            essence = best;
        }
    }
    if (!UUID.test(essence)) return {};
    const essenceMod = integer(input.essenceValues[essence] ?? 0);
    return { essence, ...(essenceMod !== 0 ? { essence_mod: essenceMod } : {}) };
}
